import * as _4 from 'lodash4';
export class ConfirmationNumberService {
  private confirmationFormat: RegExp = /\b\d{6}\b/g;

  isValidConfirmationNumber(confirmNum: string): boolean {
    return !_4.isUndefined(confirmNum) && !_4.isNull(confirmNum.match(this.confirmationFormat));
  }

  sanitizeConfirmationNumber(confirmNum: string): string {
    return _4.first(confirmNum.match(this.confirmationFormat)!);
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-notification-settings/src/services/confirmation_number_service.ts